import React, { useState } from "react";
import HeaderDashboard from "../../Components/HeaderDashboard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { flightTransactionReport } from "../../Services/ReportsApi";

const AllTransactions = () => {

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        pnr: "",
        transactionId: "",
        bookingRefNo: "",
        paymentStatus: "",
        bookingStatus: "",
    });

    const today = new Date();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleDateChange = (name, date) => {
        if (!date) {
            setFilters((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const formatted = `${day}/${month}/${year}`;

        setFilters((prev) => ({ ...prev, [name]: formatted }));
    };
    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Handle Search Button Click
    const handleSearch = async () => {
        setLoading(true);
        try {
            // Prepare the request payload
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                GDSPNR: filters.pnr,
                TrackID: filters.transactionId,
                ReferenceNo: filters.bookingRefNo,
                PaymentStatus: filters.paymentStatus,
                BookingStatus: filters.bookingStatus,
                UserName: "",
            };


            //  Call API from external service
            const data = await flightTransactionReport(requestBody);

            console.log(data);
            setTransactions(data || []);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard />
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reports</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>

                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row">
                        {/* <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <input
                                className="form-control form-control-solid"
                                type="date"
                                name="fromDate"
                                value={filters.fromDate}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <input
                                className="form-control form-control-solid"
                                type="date"
                                name="toDate"
                                value={filters.toDate}
                                onChange={handleChange}
                            />
                        </div> */}
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <DatePicker
                                selected={parseDate(filters.fromDate)}
                                onChange={(date) => handleDateChange("fromDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="From Date"
                                maxDate={today}
                                className="form-control form-control-solid"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <DatePicker
                                selected={parseDate(filters.toDate)}
                                onChange={(date) => handleDateChange("toDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="To Date"
                                minDate={parseDate(filters.fromDate)}     // disable before fromDate
                                maxDate={today}                           // disable future dates
                                className="form-control form-control-solid"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>PNR Number</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="pnr"
                                value={filters.pnr}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Transaction ID</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="transactionId"
                                value={filters.transactionId}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Booking RefNo</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="bookingRefNo"
                                value={filters.bookingRefNo}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Payment Status</label>
                            <select
                                className="form-select form-select-solid"
                                name="paymentStatus"
                                value={filters.paymentStatus}
                                onChange={handleChange}
                            >
                                <option value="">- Select -</option>
                                <option value="Success">Success</option>
                                <option value="Requested">Requested</option>
                                <option value="Failure">Failure</option>
                                <option value="Refunded">Refunded</option>
                                <option value="UnPaid">UnPaid</option>
                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Booking Status</label>
                            <select
                                className="form-select form-select-solid"
                                name="bookingStatus"
                                value={filters.bookingStatus}
                                onChange={handleChange}
                            >
                                <option value="">- Select -</option>
                                <option value="Confirmed">Confirmed</option>
                                <option value="Hold">Hold</option>
                                <option value="Failure">Failure</option>
                                <option value="Released">Released</option>
                                <option value="OnRequest">OnRequest</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Voided">Voided</option>
                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className='wraper'>
                <div className='box_shadow'>
                    <div className='col-md-12 col-lg-12'>
                        <div class="table-responsive">
                            <table class="table align-middle gs-0 gy-4">
                                <thead>
                                    <tr class="fw-bold bg-light">
                                        <th class="ps-4 rounded-start">Sr No</th>
                                        <th>RefNo.</th>
                                        <th>Payment Status</th>
                                        <th>Booking Status</th>
                                        <th>PNR</th>
                                        <th>Ticketing Status</th>
                                        <th>Booking Date</th>
                                        <th>Fare</th>
                                        <th>Sector</th>
                                        <th>Travel Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions?.allTransactions?.airTransactionResponse?.length > 0 ? (
                                        transactions?.allTransactions?.airTransactionResponse?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.referenceNo}</td>
                                                <td>{item.paymentStatus}</td>
                                                <td>{item.bookingStatus}</td>
                                                <td>{item.gdspnr}</td>
                                                <td>{item.ticketingStatus}</td>
                                                <td>{item.insertedOn}</td>
                                                <td>{item.totalFare}</td>
                                                <td>{item.sector}</td>
                                                <td>{item.departureDate}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">
                                                {loading ? "Loading..." : "No records found"}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {/* <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>RTFA9</td>
                                        <td>Success</td>
                                        <td>Confirmed</td>
                                        <td>D7QJVC</td>
                                        <td>OnRequest</td>
                                        <td>11 Sep 2025 11:34</td>
                                        <td>13/03/2026</td>
                                        <td class="text-center">
                                            <a href="/Settings/Suppliers/detailsupplier" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-switch fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-pencil fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                                <i class="ki-outline ki-trash fs-2"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>RTFA9</td>
                                        <td>Success</td>
                                        <td>Confirmed</td>
                                        <td>D7QJVC</td>
                                        <td>OnRequest</td>
                                        <td>11 Sep 2025 11:34</td>
                                        <td>13/03/2026</td>
                                        <td class="text-center">
                                            <a href="/Settings/Suppliers/detailsupplier" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-switch fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-pencil fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                                <i class="ki-outline ki-trash fs-2"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>RTFA9</td>
                                        <td>Success</td>
                                        <td>Confirmed</td>
                                        <td>D7QJVC</td>
                                        <td>OnRequest</td>
                                        <td>11 Sep 2025 11:34</td>
                                        <td>13/03/2026</td>
                                        <td class="text-center">
                                            <a href="/Settings/Suppliers/detailsupplier" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-switch fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <i class="ki-outline ki-pencil fs-2"></i>
                                            </a>
                                            <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                                <i class="ki-outline ki-trash fs-2"></i>
                                            </a>
                                        </td>
                                    </tr>

                                </tbody> */}
                            </table>
                        </div>

                    </div>


                </div>
            </section>
        </>
    );
};

export default AllTransactions;
